import bitPay from "../../assets/icons/bitpay.svg";
import logo from "../../assets/icons/shy-logo-horizontal-gold.svg";
import poweredbylogo from "../../assets/icons/shy-logo-powered-by-logo.svg";
import nbaaLogo from "../../assets/images/nbaa-main-logo.svg";
import Modal from "../ui/Modal";
import useModal from "../../hooks/useModal";
import CarbonNeutral from "../shared/CarbonNeutral";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import useGet from "../../hooks/useGet";
import { getRestrictedLinks } from "../../utilities/settings";
import { getIcon, getRawIcon } from "../../utilities/icon";
import { isPelorus } from "../../utilities/poweredBy";
import PoweredByContext from "../../store/PoweredByContext";
import LazyLoadingContext from "../../store/LazyLoadingContext";
import acaLogo from "../../assets/images/aca-logo.png";

const Footer = () => {
    // State
    const [showCookieSettingsButton, setShowCookieSettingsButton] = useState(false);
    const [links, setLinks] = useState(false);

    // Hooks
    const { modalVisible, closeModal, openModal } = useModal();
    const { returnData } = useGet("/api/content/footer");
    const poweredByCtx = useContext(PoweredByContext);
    const lazyLoadingCtx = useContext(LazyLoadingContext);

    useEffect(() => {
        if (returnData !== false && returnData !== "") {
            lazyLoadingCtx.updateGlobalCheck("footer", true);
        }
    }, [returnData, lazyLoadingCtx]);

    useEffect(() => {
        if (returnData && poweredByCtx.siteReady) {
            const restrictedLinks = getRestrictedLinks(poweredByCtx.isPoweredBy);
            const filteredData = returnData.filter((link) => {
                let valid = true;

                if (restrictedLinks.length > 0) {
                    restrictedLinks.forEach((restrictedLink) => {
                        if (link.url.indexOf(restrictedLink) > -1) {
                            valid = false;
                        }
                    });
                }

                return valid;
            });

            if (isPelorus(poweredByCtx)) {
                filteredData.unshift({
                    name: poweredByCtx?.tenant?.tenantName,
                    url: "https://pelorusaviation.com",
                });
            }

            if (filteredData.length > 4) {
                const linksLength = filteredData.length / 2;

                setLinks([filteredData.slice(0, linksLength), filteredData.slice(linksLength)]);
            } else {
                setLinks([filteredData]);
            }
        }
    }, [returnData, poweredByCtx, poweredByCtx.isPoweredBy, poweredByCtx.siteReady]);

    // Set year
    const year = new Date().getFullYear();

    // Check chat is actually available on the page
    setTimeout(() => {
        if (document.getElementsByClassName("cky-btn-revisit").length) {
            setShowCookieSettingsButton(true);
        }
    }, 2500);

    // Click the hidden cookie button on behalf of user
    const cookieSettingsClick = () => {
        var btnRevisit = document.querySelector(".cky-btn-revisit");
        if (btnRevisit) {
            btnRevisit.click();
        }
    };

    const isExternalLink = (url) => {
        return url.indexOf("http") === 0;
    };

    const getSocialLink = (service) => {
        const links = {
            instagram: "https://www.instagram.com/shyaviation/?hl=en-gb",
            facebook: "https://www.facebook.com/shyaviation/",
            twitter: "https://twitter.com/shyaviation",
            tiktok: "https://www.tiktok.com/@shyaviation",
            linkedin: "https://www.linkedin.com/company/shy-aviation",
        };

        if (service) {
            if (poweredByCtx.isPoweredBy) {
                const tenantLinks = {
                    instagram: poweredByCtx.tenant?.instagram,
                    facebook: poweredByCtx.tenant?.facebook,
                    twitter: poweredByCtx.tenant?.twitter,
                    tiktok: poweredByCtx.tenant?.tiktok,
                    linkedin: poweredByCtx.tenant?.linkedin,
                };

                return tenantLinks[service] || null;
            } else if (links[service]) {
                return links[service];
            }
        }
        return null;
    };

    const showLogo = () => {
        if (poweredByCtx.isPoweredBy) {
            return poweredByCtx.tenant.showPoweredByLogo;
        }
        return true;
    };

    const hasCarbonNeutralLink = () => {
        if (poweredByCtx.isPoweredBy) {
            return poweredByCtx.tenant.tenantCarbonNeutralUrl !== undefined;
        }
        return false;
    };

    const getCarbonNeutralLink = () => {
        if (poweredByCtx.isPoweredBy) {
            return poweredByCtx.tenant.tenantCarbonNeutralUrl;
        }
    };

    return (
        <>
            <footer className="footer">
                <div className="wrap">
                    {showLogo() && poweredByCtx.siteReady && (
                        <Link to="/" className="footer__logo-link">
                            {poweredByCtx.isPoweredBy ? (
                                <figure className="footer__powered-by-logo">
                                    <img src={poweredbylogo} alt="SHY Logo" />
                                </figure>
                            ) : (
                                <img className="footer__logo" src={logo} alt="SHY Logo" />
                            )}
                        </Link>
                    )}

                    <div className="footer__socials">
                        {getSocialLink("instagram") && (
                            <a href={getSocialLink("instagram")} rel="noreferrer" target="_blank">
                                {poweredByCtx.isPoweredBy ? (
                                    <>{getRawIcon("footer-instagram")}</>
                                ) : (
                                    <>
                                        <img src={getIcon("footer-instagram")} alt="" />
                                        <img src={getIcon("footer-instagram-hover")} alt="" />
                                    </>
                                )}
                                Instagram
                            </a>
                        )}
                        {getSocialLink("facebook") && (
                            <a href={getSocialLink("facebook")} rel="noreferrer" target="_blank">
                                {poweredByCtx.isPoweredBy ? (
                                    <>{getRawIcon("footer-facebook")}</>
                                ) : (
                                    <>
                                        <img src={getIcon("footer-facebook")} alt="" />
                                        <img src={getIcon("footer-facebook-hover")} alt="" />
                                    </>
                                )}
                                Facebook
                            </a>
                        )}
                        {getSocialLink("twitter") && (
                            <a
                                href={getSocialLink("twitter")}
                                rel="noreferrer"
                                target="_blank"
                                className="footer__socials__x"
                            >
                                {poweredByCtx.isPoweredBy ? (
                                    <>{getRawIcon("footer-twitter")}</>
                                ) : (
                                    <>
                                        <img src={getIcon("x-twitter-white")} alt="" />
                                        <img src={getIcon("x-twitter-gold")} alt="" />
                                    </>
                                )}
                                Twitter
                            </a>
                        )}
                        {getSocialLink("tiktok") && (
                            <a href={getSocialLink("tiktok")} rel="noreferrer" target="_blank">
                                {poweredByCtx.isPoweredBy ? (
                                    <>{getRawIcon("footer-tik-tok")}</>
                                ) : (
                                    <>
                                        <img src={getIcon("footer-tik-tok")} alt="" />
                                        <img src={getIcon("footer-tik-tok-hover")} alt="" />
                                    </>
                                )}
                                TikTok
                            </a>
                        )}
                        {getSocialLink("linkedin") && (
                            <a href={getSocialLink("linkedin")} rel="noreferrer" target="_blank">
                                {poweredByCtx.isPoweredBy ? (
                                    <>{getRawIcon("footer-linkedin")}</>
                                ) : (
                                    <>
                                        <img src={getIcon("footer-linkedin")} alt="" />
                                        <img src={getIcon("footer-linkedin-hover")} alt="" />
                                    </>
                                )}
                                LinkedIn
                            </a>
                        )}
                    </div>

                    {links && (
                        <div className="footer__links">
                            {links.map((linkGroup, i) => {
                                const hasCenteredLinks = linkGroup.some(
                                    (link) => link.name === "Helicopters" || link.name === "Careers"
                                );
                                const columnClassName = hasCenteredLinks
                                    ? "footer__links__column footer__links__column--centered"
                                    : "footer__links__column";

                                return (
                                    <div className={columnClassName} key={i}>
                                        {linkGroup.map((link, i) => {
                                            if (link.name === "Carbon Neutral") {
                                                if (hasCarbonNeutralLink()) {
                                                    return (
                                                        <a
                                                            href={getCarbonNeutralLink()}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            key={i}
                                                        >
                                                            {link.name}
                                                        </a>
                                                    );
                                                } else {
                                                    return (
                                                        <button onClick={openModal} key={i}>
                                                            {link.name}
                                                        </button>
                                                    );
                                                }
                                            } else {
                                                if (isExternalLink(link.url)) {
                                                    return (
                                                        <a href={link.url} target="_blank" rel="noreferrer" key={i}>
                                                            {link.name}
                                                        </a>
                                                    );
                                                } else {
                                                    return (
                                                        <Link to={link.url} key={i}>
                                                            {link.name}
                                                        </Link>
                                                    );
                                                }
                                            }
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    <div className="footer__lifestyle-info">
                        <div className="footer__lifestyle-info__logos">
                            <img
                                className="footer__lifestyle-info__aca"
                                src={acaLogo}
                                alt="The Air Charter Association - Accredited Member"
                            />
                            <div id="wyvern" className="footer__lifestyle-info__wyvern">
                                <a
                                    href="https://app.wyvern.systems/public/verification/7d707d2d15b0ffae437d7ca82c/9305/b5756bacee538-99ca856efb95a"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src="https://api.wyvern.systems/api/company/status/verify/7d707d2d15b0ffae437d7ca82c/9305/b5756bacee538/0/99ca856efb95a"
                                        alt="WYVERN Logo"
                                    />
                                </a>
                            </div>
                            {/* <img src={sgsLogo} alt="SGS ARGUS logo" /> */}
                            {/* <img src={ebaaLogo} alt="EBAA logo" /> */}
                            <img src={nbaaLogo} alt="NBAA logo" />
                        </div>
                    </div>

                    <div className="footer__final-links">
                        <img className="footer__final-links__bitpay" src={bitPay} alt="" />

                        <div className="footer__final-links__legal-info">
                            <Link to="/terms-conditions">Terms & Conditions</Link>
                            <div className="footer__final-links__legal-info__divide" />
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            {showCookieSettingsButton && (
                                <>
                                    <div className="footer__final-links__legal-info__divide" />
                                    <button onClick={cookieSettingsClick}>Cookie Settings</button>
                                </>
                            )}
                        </div>

                        <div className="footer__final-links__copyright">© Copyright SHY Aviation {year}.</div>
                    </div>
                </div>
            </footer>

            <Modal modalVisible={modalVisible} closeModal={closeModal}>
                <CarbonNeutral closeModal={closeModal} />
            </Modal>
        </>
    );
};

export default Footer;
